import { lazy, Suspense, useState, useEffect } from "react";
import { useCatalog } from "./Catalog.context";

export default function CatalogPageRouter() {
  const {
    configs: { pageMap },
    lang,
    pageName,
  } = useCatalog();
  const [pages, setPages] = useState([]);

  useEffect(() => {
    if (lang) {
      setPages(
        pageMap[lang]?.map((page) => ({
          name: page.name,
          component: lazy(() => import(`pages/${lang}/${page.name}`)),
        })),
      );
    }
  }, [lang, pageMap]);

  const Page = pages.find((page) => page.name === pageName);

  return <Suspense>{Page && <Page.component />}</Suspense>;
}
